import React from 'react';
import ProfessionalHub from './ProfessionalHub';

export default function DietitianPanel() {
  return <ProfessionalHub requiredType="dietitian" panelTitle="Diyetisyen Paneli" />;
}

